angular.module('zc.projects')

.directive 'zcCampaignCouponApplicableRate', (CampaignSegmentStats, Devise) ->
  restrict: 'E'
  scope: {
    project: '='
    campaign: '='
    filters: '='
  }
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_coupon_applicable_rate.html'

  link: (scope, element, attrs) ->
    scope.Devise = Devise
    updateData = ->
      CampaignSegmentStats.aggregate
        apikey: scope.project.apikey
        dimension: 'daily'
      ,
        match:
          campaign_id: scope.campaign.id,
          start_at:
            $gte: moment(scope.filters.start_at).toDate()
            $lt: moment(scope.filters.end_at).endOf('day').toDate()
        pipeline: [
          $group:
            _id: null
            conversion_count:
              $sum: '$conversion_count'
            coupon_applicable_conversion_count:
              $sum: '$coupon_applicable_conversion_count'
        ]
      .then (stats) ->
        stat = stats[0]
        if stat and stat.conversion_count > 0
          scope.coupon_applicable_rate = stat.coupon_applicable_conversion_count / stat.conversion_count
        else
          scope.coupon_applicable_rate = null

    scope.$watch 'filters', updateData, true



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/campaign_coupon_applicable_rate.directive.coffee